import { WorkspaceTypeID } from './workspaces/dto';

export const arrayParamsSerializer = (params: Record<string, unknown>) => {
  const urlParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value == null) return;

    if (Array.isArray(value)) {
      urlParams.set(key, JSON.stringify(value));
    } else {
      urlParams.set(key, String(value));
    }
  });

  return urlParams.toString();
};

const V7_WORKSPACE_TYPE_IDS = [
  WorkspaceTypeID.HCPSiteAnalytics,
  WorkspaceTypeID.DTC,
  WorkspaceTypeID.BrandExplorer,
  WorkspaceTypeID.ListMatchingConsent,
  WorkspaceTypeID.MedscapeSoftMatch,
];

//TODO: Remove after migration is done
export const workspaceTypeChecks = {
  isV7Workspace: (typeId?: WorkspaceTypeID) => (typeId ? V7_WORKSPACE_TYPE_IDS.includes(typeId) : false),
  isConsentLikeWorkspace: (typeId?: WorkspaceTypeID) =>
    typeId ? [WorkspaceTypeID.ListMatchingConsent, WorkspaceTypeID.MedscapeSoftMatch].includes(typeId) : false,
  isHCPSiteAnalytics: (typeId?: WorkspaceTypeID) =>
    typeId ? [WorkspaceTypeID.HCPSiteAnalytics].includes(typeId) : false,

  isThrotleOrMediaEffectiveness: (typeId?: WorkspaceTypeID) =>
    typeId ? [WorkspaceTypeID.Throtle, WorkspaceTypeID.MediaEffectiveness].includes(typeId) : false,

  isBrandExplorerWorkspace: (typeId?: WorkspaceTypeID) => (typeId ? WorkspaceTypeID.BrandExplorer === typeId : false),
};
